import { VDriveProviderInfo, handleError } from '@vgrubs/components';
import { isAxiosError } from 'axios';

// Helper function to compare providers arrays by their contents
export const areProvidersEqual = (
  a: VDriveProviderInfo[],
  b: VDriveProviderInfo[] | undefined
): boolean => {
  if (!b) return false;
  if (a.length !== b.length) return false;

  // Sort both arrays by provider to ensure consistent comparison
  const sortedA = [...a].sort((x, y) =>
    String(x.provider).localeCompare(String(y.provider))
  );
  const sortedB = [...b].sort((x, y) =>
    String(x.provider).localeCompare(String(y.provider))
  );

  return sortedA.every(
    (item, index) =>
      item.provider === sortedB[index].provider &&
      item.enabled === sortedB[index].enabled
  );
};

/**
 * The reserve each level gives a balance no admin set a limit for, in cents.
 * Only for display - the backend sends the effective limit in
 * `overdraftLimit`, and saving `null` is how a balance goes back to its level.
 */
export const RESERVE_BY_LEVEL: Record<number, number> = {
  1: 10000,
  2: 20000,
  3: 30000,
};

/** `pendingBank` for a vDrive that has not loaded, or a backend without it. */
export const NO_PENDING_BANK = { count: 0, total: 0, balanceCredit: 0 };

/**
 * The ACH Customer ID field's tooltip, on every screen that edits it. The old
 * copy described collecting what the vGrubs vDrive card had spent (3% fee,
 * charged Monday and Thursday nights), which the card's retirement ended.
 */
export const ACH_CUSTOMER_ID_TOOLTIP =
  "The owner's GoCardless customer, used for bank (ACH) payments: SaaS charges and vDrive balance payments. When the owner's cards are declined, a vDrive top-up comes from the location's vGrubs balance first, and a bank payment is started on its own for what that does not cover. Bank payments take 3-5 business days to clear.";

/** The 400 every vDrive fleet route answers when this environment has no vDrive key. */
export const isFleetIntegrationNotConfigured = (error: unknown) =>
  isAxiosError(error) &&
  error.response?.status === 400 &&
  /not configured/i.test(String(handleError(error) ?? ''));
